import React from 'react'

import { Card } from '@grandvisionhq/common'
import type { SummarySlotType } from '@grandvisionhq/lib-form-slots'
import { useIntl } from '@grandvisionhq/state'

import { formatDateOfBirth, isValidDate } from '../../../util/date-utils'

type Props = {
  values?: {
    firstName?: string
    lastName?: string
    phone?: string
    dateOfBirth?: string
  }
  email: string
}

const PersonalDetailsSummary: SummarySlotType<Props> = ({ actions, values = {}, email }) => {
  const { getLabel, locale } = useIntl()
  const date = values.dateOfBirth || ''

  return (
    <Card>
      <Card.Content>
        {actions?.onEdit && (
          <Card.Actions>
            <Card.Button onClick={actions.onEdit} children={getLabel('common.actions.edit')} />
          </Card.Actions>
        )}
        {(values.firstName || values.lastName) && (
          <Card.Text variant="body-head">
            {values.firstName} {values.lastName}
          </Card.Text>
        )}
        {isValidDate(date) && <Card.Text>{formatDateOfBirth(date, locale)}</Card.Text>}
        {values.phone && <Card.Text>{values.phone}</Card.Text>}
        <Card.Text>{email}</Card.Text>
      </Card.Content>
    </Card>
  )
}

export default PersonalDetailsSummary
